module.exports = __webpack_public_path__ + "img/certImg3.66cc6309.png";